/* eslint-disable react-refresh/only-export-components */
// Disabled: Standard React Context pattern - exporting Provider + hook together

import React, { createContext, useContext, useState, useCallback } from 'react';

/**
 * UI Context state
 */
export interface UIContextType {
  /** Sidebar collapsed state */
  sidebarCollapsed: boolean;
  /** Toggle sidebar collapsed state */
  toggleSidebar: () => void;
  /** Set sidebar collapsed state */
  setSidebarCollapsed: (collapsed: boolean) => void;
  /** Mobile menu open state */
  mobileMenuOpen: boolean;
  /** Set mobile menu open state */
  setMobileMenuOpen: (open: boolean) => void;
}

const UIContext = createContext<UIContextType | undefined>(undefined);

/**
 * UI Context Provider
 * Manages global UI state like sidebar visibility
 */
export const UIProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleSidebar = useCallback(() => {
    setSidebarCollapsed((prev) => !prev);
  }, []);

  const value: UIContextType = {
    sidebarCollapsed,
    toggleSidebar,
    setSidebarCollapsed,
    mobileMenuOpen,
    setMobileMenuOpen,
  };

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};

/**
 * Hook to access UI context
 */
export const useUI = (): UIContextType => {
  const context = useContext(UIContext);
  if (context === undefined) {
    throw new Error('useUI must be used within a UIProvider');
  }
  return context;
};

export default UIContext;
